module.exports = __webpack_public_path__ + "assets/img/Future_004.d90fa72a-ps.jpg";